<template>
  <div class="va-field va-radio" :class="{ label: computedLabel }">
    <label v-if="computedLabel" class="title-label">{{ computedLabel }}</label>
    <label
      v-for="(value, key) in computedOptions"
      :key="key"
      class="radio"
      :for="'_' + uid + key"
    >
      {{ value }}
      <input
        :id="'_' + uid + key"
        type="radio"
        :name="uid + fieldModel.fieldName"
        :checked="data[fieldModel.fieldName] == key"
        @change="select"
      />
      <label :for="'_' + uid + key" class="radio-style" />
    </label>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    fieldModel: {
      type: Object,
      required: true,
    },
  },
  emits: ['updatedData'],
  data() {
    return {
      editMode: false,
      uid: uuidv4(),
    };
  },
  computed: {
    computedLabel: function () {
      if (
        this.fieldModel &&
        typeof this.fieldModel.label === 'object' &&
        this.fieldModel.label !== null
      ) {
        if (this.fieldModel.label[this.$getUserlanguage()]) {
          return this.fieldModel.label[this.$getUserlanguage()];
        }
        return this.fieldModel.label['en_US'];
      } else {
        return this.fieldModel.label;
      }
    },
    computedOptions: function () {
      let computedOptions = {};
      Object.keys(this.fieldModel.options).map((key) => {
        if (
          typeof this.fieldModel.options[key] === 'object' &&
          this.fieldModel.options[key] !== null
        ) {
          if (this.fieldModel.options[key][this.$getUserlanguage()]) {
            return (computedOptions[key] =
              this.fieldModel.options[key][this.$getUserlanguage()]);
          } else {
            return (computedOptions[key] =
              this.fieldModel.options[key]['en_US']);
          }
        } else {
          return (computedOptions[key] = this.fieldModel.options[key]);
        }
      });
      return computedOptions;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (
        !this.data[this.fieldModel.fieldName] &&
        Object.keys(this.fieldModel.options)?.length
      ) {
        var selectData = {
          target: { id: Object.keys(this.fieldModel.options)[0] },
          returnValue: true,
        };
        this.select(selectData);
      }
    });
  },
  methods: {
    select: function (e) {
      if (e.returnValue) {
        // TODO Fix no-mutating-props issue
        // eslint-disable-next-line vue/no-mutating-props
        this.data[this.fieldModel.fieldName] = e.target.id.replace(
          '_' + this.uid,
          '',
        );
        this.$emit('updatedData');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.va-radio {
  position: relative;
  text-align: left;

  .radio {
    display: inline-block;
    position: relative;
    padding-left: 1.5rem;
    margin: 0 1rem 0.5rem 0;
    cursor: pointer;
    user-select: none;
    color: $color-text-secondary;
    font-size: 0.875rem;
    line-height: 1rem;

    input {
      position: absolute;
      opacity: 0;
    }

    .radio-style {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      height: 1rem;
      width: 1rem;
      margin: 0;
      padding: 0;
      background-color: $color-fill-inactive;
      border: 1px solid $color-action-border;
      border-radius: 50%;
    }

    .radio-style::after {
      content: '';
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: $ixm-white;
    }

    input:checked ~ .radio-style::after {
      display: block;
    }

    &:hover input ~ .radio-style {
      border-color: $color-action-border-hover;
    }

    input:checked ~ .radio-style {
      background-color: $color-fill-active;
      border-color: $color-fill-active;
    }
  }
}
</style>
